/** Tenant provisoire avant la connexion Cloud (e-mail / mot de passe). */
export const CLOUD_WEB_PLACEHOLDER_TENANT = 'cloud-web-tenant';

let hostOverride: boolean | null = null;

/** Tests uniquement : force (ou libère avec `null`) la détection de l'hôte Cloud navigateur. */
export function setBrowserCloudHostForTests(value: boolean | null): void {
  hostOverride = value;
}

/** Hôte Cloud SaaS publié (`npm run build`, sans Electron). */
export function isBrowserCloudHost(): boolean {
  if (hostOverride !== null) return hostOverride;
  return typeof window !== 'undefined' && !window.electron && Boolean(import.meta.env.PROD);
}

export function isCloudWebPlaceholderTenant(tenantId: string | undefined): boolean {
  return tenantId === CLOUD_WEB_PLACEHOLDER_TENANT;
}
